import { useState } from 'react'

/** Piezas para componer contenidos de ayuda con el mismo aspecto en todos los temas. */
export const AyudaSec = ({ titulo, children }) => (
  <section className="ayuda-sec">
    <h3>{titulo}</h3>
    {children}
  </section>
)

export const AyudaCod = ({ children }) => <pre className="ayuda-cod">{children}</pre>

/** Código con botón de copiar (comandos, URLs). */
export function AyudaCopiable({ texto }) {
  const [copiado, setCopiado] = useState(false)
  const copiar = async () => {
    try {
      await navigator.clipboard.writeText(texto)
      setCopiado(true)
      setTimeout(() => setCopiado(false), 1600)
    } catch { /* http o permiso denegado: queda el seleccionar a mano */ }
  }
  return (
    <div className="copiable">
      <pre className="ayuda-cod" style={{ margin: 0, flex: 1 }}>{texto}</pre>
      <button className="btn sm secondary" onClick={copiar}>{copiado ? '✓' : 'Copiar'}</button>
    </div>
  )
}
